import { Tabs as TabsComponent, TabsProps } from '@/components/chariot-ui';
import { useEffect } from 'react';

import { useGlobalState } from '@/state/global.state';

const Tabs = (
  props: TabsProps & {
    id: string;
    keyboardDependencies?: string[];
    keyboardNavigation?: boolean;
  }
) => {
  const { tabs, selected, onSelect, vertical, ...rest } = props;
  const { id, keyboardDependencies = [], keyboardNavigation = true } = rest;
  const { keyboardListeners } = useGlobalState();

  useEffect(() => {
    function handleNext(event: KeyboardEvent) {
      event.preventDefault();
      const foundIndex = tabs.findIndex(tab => tab.value === selected?.value);
      const currentTabIndex = foundIndex === -1 ? 0 : foundIndex;
      const nextTabIndex =
        currentTabIndex === tabs.length - 1 ? 0 : currentTabIndex + 1;
      const nextTab = tabs[nextTabIndex];

      if (nextTab) {
        onSelect(nextTab);
      }
    }

    function handlePrevious(event: KeyboardEvent) {
      event.preventDefault();
      const foundIndex = tabs.findIndex(tab => tab.value === selected?.value);
      const currentTabIndex = foundIndex === -1 ? 0 : foundIndex;
      const previousTab =
        currentTabIndex === 0
          ? tabs[tabs.length - 1]
          : tabs[currentTabIndex - 1];
      if (previousTab) {
        onSelect(previousTab);
      }
    }

    if (keyboardNavigation) {
      if (vertical) {
        keyboardListeners.add(id, {
          ArrowDown: handleNext,
          ArrowUp: handlePrevious,
        });
      } else {
        keyboardListeners.add(id, {
          ArrowRight: handleNext,
          ArrowLeft: handlePrevious,
        });
      }
    }
  }, [
    ...keyboardDependencies,
    vertical,
    keyboardNavigation,
    JSON.stringify({
      tabs: tabs.map(tab => tab.value),
      selected: selected?.value,
    }),
  ]);

  useEffect(() => {
    return () => {
      keyboardListeners.remove(id);
    };
  }, []);

  return <TabsComponent {...props} />;
};

export default Tabs;
